<template>
    <div class="comment" :class="`comment-${comment.id}`">
        <div class="comment-box">
            <div class="comment-header">
                <span><strong>{{ comment.name }}</strong></span>
            </div>
            <div class="d-inline-block mb-3 position-relative">
                <p class="comment-text mb-0">{{ comment.comment }}</p>
                <CommentLikeCounter v-on:likeListModalOpened="showCommentLikeListModal" :commentLikes="commentLikes"/>
            </div>
            <div class="comment-footer">
                <div class="comment-actions d-flex align-items-end justify-content-start">
                    <CommentLikeButton :comment="comment" :user="user" :commentLikes="commentLikes" v-on:likeToggled="toggleCommentLike"/>
                    <a class="mr-3 small" v-on:click="openComment">Reply</a>
                    <p class="comment-date small mb-0 font-weight-bold">{{ comment.formatted_created_at }}</p>
                </div>
            </div>
        </div>
        <div class="comment-form comment-v" v-if="showCommentBox">
            <form @submit.prevent="saveReply">
                <div class="form-row">
                    <FormTextarea v-model="replyForm.message" placeholder="Add reply..."></FormTextarea>
                    <ValidationError v-if="replyForm.error.status">{{ replyForm.error.message }}</ValidationError>
                </div>
                <div class="form-row">
                    <FormButton :pending="replyForm.pending" pending-text="Saving" :disabled="!replyForm.message.length">{{ replyForm.buttonText }}</FormButton>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import FormTextarea from '@/components/form/FormTextarea';
import FormButton from '@/components/form/FormButton';
import ValidationError from '@/components/form/ValidationError';
import CommentLikeButton from '@/components/blog/CommentLikeButton';
import CommentLikeCounter from '@/components/blog/CommentLikeCounter';

export default {
    components: {
        CommentLikeCounter,
        CommentLikeButton,
        FormTextarea,
        FormButton,
        ValidationError
    },
    props: {
        post: {
            type: Object
        },
        user: {
            type: Object
        },
        comment: {
            type: Object
        },
        commentLikes: {
            type: Array,
            default() {
                return [];
            }
        },
        replyToId: {
            type: Number
        }
    },
    data() {
        return {
            showCommentBox: false,
            commentBoxes: [],
            replyForm: {
                pending: false,
                buttonText: "Reply",
                message: null,
                error: {
                    status: false,
                    message: null
                }

            }
        }
    },
    methods: {
        openComment() {
            this.replyForm.message = "";
            this.replyForm.message = "@" + this.comment.name + " ";

            this.showCommentBox = !this.showCommentBox;
        },
        async saveReply() {
            this.clearErrors();

            this.$emit('commentReplied', {
                commentId: this.replyToId ? this.replyToId : this.comment.id,
                message: this.replyForm.message
            });

            this.resetForm();
            this.showCommentBox = false;
        },
        setError(msg) {
            this.replyForm.error.status = true;
            this.replyForm.error.message = msg;
        },
        clearErrors() {
            this.replyForm.error.status = false;
            this.replyForm.error.message = null;
        },
        resetForm() {
            this.replyForm.message = '';
            this.replyForm.pending = false;
        },
        toggleCommentLike(commentLike) {
            this.$emit('likeToggled', {
                comment_id: commentLike.comment_id
            })
        },
        showCommentLikeListModal(likeList) {
            this.$emit('likeListModalOpened', likeList);
        }
    }
}
</script>

<style lang="scss" scoped>
    .comment-box {
        padding: 0px 10px 10px 0px;
        line-height: 1.5em;
    }

    .comment-date {
        color: #666666;
    }

    .comment-text {
        font-size: 1.1rem;
    }

    .comment-actions {
        font-size: 1rem;
        width: 250px;

        p, a {
            line-height: 1;
        }
    }
</style>
